(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["juvorra-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('juvorra-size-guide')) {
  customElements.define('juvorra-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const dialog = this.querySelector('dialog');
      const opener = this.querySelector('.juvorra-size-open');
      opener.addEventListener('click', () => dialog.showModal());
      this.querySelector('.juvorra-size-close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => opener.focus());
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
